import React from 'react';
import styled, { css } from 'styled-components';
import GridContainer from './GridContainer';
import GridRow from './GridRow';
import { colors } from '../theme/ColorTheme';
import mediaQ from '../theme/responsive';
import * as Selectors from '../store/selectors';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { FormattedHTMLMessage } from 'react-intl';

class Wasseranschluesse extends React.Component {
    render() {
        const {
            heading,
            trinkwasserSteigstrang,
            trinkwasserAnschlussleitung,
            abwasserFallleitung,
            abwasserAnschlussleitung,
            setTrinkwasserSteigstrang,
            setTrinkwasserAnschlussleitung,
            setAbwasserFallleitung,
            setAbwasserAnschlussleitung,
            trinkwasserSteigstrangActive,
            trinkwasserAnschlussleitungActive,
            abwasserFallleitungActive,
            abwasserAnschlussleitungActive,
            possibleRohrleitungen,
        } = this.props;
    
        return (
            <GridContainer heading={heading}>
                <GridRowWithImages
                    setChoice={setTrinkwasserSteigstrang}
                    label={<FormattedHTMLMessage id="steigstrang-des-versorgungs-systems-label" />}
                    items={trinkwasserSteigstrang}
                    active={trinkwasserSteigstrangActive}
                  
                />
                <GridRowWithImages
                    setChoice={setTrinkwasserAnschlussleitung}
                    label={<FormattedHTMLMessage id="anschlussleitungen-des-versorgungs-systems-label" />}
                    items={trinkwasserAnschlussleitung}
                    active={trinkwasserAnschlussleitungActive}
                />
                <GridRowWithImages
                    setChoice={setAbwasserFallleitung}
                    label={<FormattedHTMLMessage id="fallleitung-des-entwaesserungs-systems-label" />}
                    items={abwasserFallleitung}
                    active={abwasserFallleitungActive}
                    wichFallLeitungIsDisabled={possibleRohrleitungen.wichFallLeitungIsDisabled}
                />
                <GridRowWithImages
                    setChoice={setAbwasserAnschlussleitung}
                    label={<FormattedHTMLMessage id="anschlussleitungen-des-entwaesserungs-systems-label" />}
                    items={abwasserAnschlussleitung}
                    active={abwasserAnschlussleitungActive}
                    wichAnschlussLeitungIsDisabled={possibleRohrleitungen.wichAnschlussLeitungIsDisabled}
                />
            </GridContainer>
        );
    }
}

const GridRowWithImages = ({ label, items, setChoice, active, wichAnschlussLeitungIsDisabled, wichFallLeitungIsDisabled, hideLastItem }) => {
    const toggleActiveItem = item => {
        return item === active ? true : false;
    };
    return ( 
        <GridRow wasserRow={true} label={label}>
            <AnschlussRow hideLastItem={hideLastItem}>
                {items.map(item => (
                    <AnschlussItem
                        wichAnschlussLeitungIsDisabled={wichAnschlussLeitungIsDisabled}
                        wichFallLeitungIsDisabled={wichFallLeitungIsDisabled}
                        rohrValue={item.value}
                        onClick={() => setChoice(item.value)}
                        key={item.label}>
                        <img src={`./assets/img/${item.image}`} />
                        <AnschlussOverlay setVisibility={toggleActiveItem(item.value)}>
                            <span>{ReactHtmlParser(item.label)}</span>
                        </AnschlussOverlay>
                    </AnschlussItem>
                ))}
            </AnschlussRow>
        </GridRow>
    );
};

const mapStateToProps = state => ({
    trinkwasserSteigstrang: Selectors.getTrinkwasserSteigstrangChoices(state),
    trinkwasserAnschlussleitung: Selectors.getTrinkwasserAnschlussleitungChoices(state),
    abwasserFallleitung: Selectors.getAbwasserFallleitungChoices(state),
    abwasserAnschlussleitung: Selectors.getAbwasserAnschlussleitungChoices(state),
    trinkwasserSteigstrangActive: state.choices.trinkwasserSteigstrang,
    trinkwasserAnschlussleitungActive: state.choices.trinkwasserAnschlussleitung,
    abwasserFallleitungActive: state.choices.abwasserFallleitung,
    abwasserAnschlussleitungActive: state.choices.abwasserAnschlussleitung,
    possibleRohrleitungen: Selectors.getPossibleRohrleitungen(state),
});

const mapDispatchToProps = dispatch => ({
    setTrinkwasserSteigstrang: value => dispatch({ type: 'SET_CHOICE__TRINKWASSER_STEIGSTRANG', value }),
    setTrinkwasserAnschlussleitung: value => dispatch({ type: 'SET_CHOICE__TRINKWASSER_ANSCHLUSSLEITUNG', value }),
    setAbwasserFallleitung: value => dispatch({ type: 'SET_CHOICE__ABWASSER_FALLLEITUNG', value }),
    setAbwasserAnschlussleitung: value => dispatch({ type: 'SET_CHOICE__ABWASSER_ANSCHLUSSLEITUNG', value }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Wasseranschluesse);

const AnschlussRow = styled.div`
    align-items: center;
    justify-content: flex-start;
    display: flex;
    line-height:20px;
    width: 170%;
    ${mediaQ.tablet`
        width: 100%;
    `}
    ${mediaQ.phone`
        justify-content: space-between;
    `}
    & ${AnschlussRow}:nth-child(3) {
        margin-right: 0;
        ${props => (props.hideLastItem ? 'opacity: 0; pointer-events: none' : '')}
    }
    & ${AnschlussRow}:nth-child(1) {
        ${mediaQ.tablet`
            margin-left: 0;
        `}
    }
`;

const AnschlussOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    border: solid 0.3rem #376EB4;
    background-color: rgba(255, 255, 255, 0.8);
    color: ${colors.black};
    height: 100%;
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    ${props => (props.setVisibility ? Active : Inactive)}
    padding: 1rem;
    span {
        font-family: GROTESK Regular !important;
    }
    ${mediaQ.phone`
        text-align: center;
        font-size: 80%;
        word-break: break-word;
    `}
`;

const Active = css`
    visibility: visible;
`;

const Inactive = css`
    visibility: hidden;
`;

const AnschlussItem = styled.div`
    opacity: ${props => {
        const wichAnschlussLeitungIsDisabled = props.wichAnschlussLeitungIsDisabled;
        if (wichAnschlussLeitungIsDisabled == null) {
            return;
        } else {
            return wichAnschlussLeitungIsDisabled.includes(props.rohrValue) ? '1' : '0.5';
        }
    }};
    opacity: ${props => {
        const wichFallLeitungIsDisabled = props.wichFallLeitungIsDisabled;
        if (wichFallLeitungIsDisabled == null) {
            return;
        } else {
            return wichFallLeitungIsDisabled.includes(props.rohrValue) ? '1' : '0.5';
        }
    }};
    margin-right: 40px;
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    &:hover {
        ${AnschlussOverlay} {
            visibility: visible;
        }
    }
    img {
        height: auto;
        width: 100%;
        object-fit: cover;
        cursor: pointer;
    }
    ${mediaQ.tablet`
        margin-right: auto;
        margin-left: auto;
        margin: 10px;
    `}
    ${mediaQ.smallPhone`
        height: 100%;
        width: 100%;
    `}
`;
